import { render, staticRenderFns } from "./add.vue?vue&type=template&id=9dcd87c8&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=9dcd87c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcd87c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dcd87c8')) {
      api.createRecord('9dcd87c8', component.options)
    } else {
      api.reload('9dcd87c8', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=9dcd87c8&scoped=true", function () {
      api.rerender('9dcd87c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pluginManage/pluginTactics/components/add.vue"
export default component.exports